import Seo from "../../Components/SEO/Seo";
import Container from "../../Components/Container/Container";
import "../../Style/legal/legal.css";

export default function Cookies() {
  return (
    <div className="legal-page">
      <Seo
        title="Cookies Policy | Conectify Tech"
        description="Learn what cookies are, how Conectify Tech uses them for localization and preference retention, and how to control your settings."
      />

      <Container className="legal-container">
        <header className="legal-header">
          <span className="section-eyebrow eyes">Tracking & Transparency</span>
          <h1 className="legal-header__title">Cookies Policy</h1>
          <p className="legal-header__date">Last Updated: September 2026</p>
        </header>

        <article className="legal-card legal-content">
          <p>
            This Cookies Policy explains what Cookies are, how <strong>Conectify Tech</strong> (“we”, “us”, or “our”) 
            uses them on <strong>conectify-tech.com</strong>, and your choices regarding their storage on your devices.
          </p>

          <h2>1. What Are Cookies?</h2>
          <p>
            Cookies are small text files placed on your computer, mobile device, or browser by a website. They allow 
            the website to recognize your browser, retain session preferences, and remember stateful information such 
            as selected language or UI display modes.
          </p>
          <div className="legal-callout">
            Cookies do not typically contain personally identifiable information; however, information stored in Cookies 
            may be associated with personal records maintained in accordance with our <a href="/privacy">Privacy Policy</a>. 
            We never store passwords or sensitive financial credentials in cookies.
          </div>

          <h2>2. Types of Cookies We Use</h2>
          <p>
            We utilize both <strong>Session Cookies</strong> (which expire immediately when you close your browser) 
            and <strong>Persistent Cookies</strong> (which remain stored on your device until a defined expiration date):
          </p>

          <h3>A. Necessary & Security Cookies</h3>
          <p>
            <strong>Type:</strong> Session Cookies<br />
            <strong>Purpose:</strong> Essential for providing core website functionality, routing requests securely, 
            authenticating user sessions, and mitigating fraudulent form submissions. Without these, our platform cannot 
            operate properly.
          </p>

          <h3>B. Functionality & Preference Cookies</h3>
          <p>
            <strong>Type:</strong> Persistent Cookies<br />
            <strong>Purpose:</strong> Used to retain choices you make when navigating our site, including:
          </p>
          <ul>
            <li><strong>Language Preference:</strong> Remembering whether you selected English or French (`googtrans` cookie) across views.</li>
            <li><strong>Display Theme:</strong> Preserving your selection between Light (Day) and Dark mode.</li>
            <li><strong>Navigation State:</strong> Retaining interactive UI settings to avoid repeated configuration prompts.</li>
          </ul>

          <h2>3. Managing Your Cookie Choices</h2>
          <p>
            If you prefer to prevent the storage of cookies from our website, you can configure your browser to reject 
            or purge them. To adjust your preferences, visit the official support page for your browser:
          </p>
          <ul>
            <li><a href="https://support.google.com/accounts/answer/32050" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
            <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          </ul>
          <p>
            <em>Note: Disabling cookies may disrupt certain website features, such as automated language switching and theme memory.</em>
          </p>

          <h2>4. Inquiries & Contact</h2>
          <p>If you have any questions regarding our Cookies Policy, please reach out to our team:</p>
          <div className="legal-address-box">
            <div className="legal-address-card">
              <h4>India (Global HQ)</h4>
              <p>Mount Motor Gali, Ratu Road, Alkapuri</p>
              <p>Near Kidzee School, Ranchi - 834001</p>
              <p>Jharkhand, India</p>
              <p className="mt-2 text-primary font-semibold">info@conectify-tech.com</p>
            </div>
            <div className="legal-address-card">
              <h4>United States</h4>
              <p>1000 Brickell Ave Ste</p>
              <p>Miami, FL 33131</p>
              <p>USA</p>
              <p className="mt-2 text-primary font-semibold">+1 786 776 2152</p>
            </div>
          </div>
        </article>
      </Container>
    </div>
  );
}